import classNames from 'classnames';
import React from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

const options = [1, 2, 3, 4, 5];

function SelectQuantity({ value, onChange, isSelfOrderingEnabled, className }) {
  const { t } = useTranslation();
  // const storage = useStorage();
  // const { swalSelectClasses } = useSwal({ storage });
  // const componentRef = useRef(ref);
  // const ref = useRef(null);

  // useEffect(() => {
  //    componentRef.current = selectEl.current;
  // }, [ref])

  return (
    <Form.Control
      // ref={ref}
      value={value}
      className={classNames(className)}
      onChange={(event) => onChange(event.target.value)}
      // disabled={disabled}
      as="select"
      size="md"
    >
      {/* <option disabled value={0}>Escolha a quantidade</option> */}
      <option value={0}>
        {t(
          isSelfOrderingEnabled
            ? 'order.choose-quantity'
            : 'order.calculate-by-quantity'
        )}
      </option>

      {options.map((quantity) => (
        <option key={`${SelectQuantity.name}-${quantity}`} value={quantity}>
          {t('order.quantity-items', { count: quantity })}
        </option>
      ))}
    </Form.Control>
  );
}

// const SelectQuantityRef = forwardRef(SelectQuantity);

export { SelectQuantity };
